import {
  FilterType,
  buildGetBookingsDataTableFilter,
  useGetBookingsDataTable,
} from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const dateFilter = (source: ReturnType<typeof useGetBookingsDataTable>) =>
  buildGetBookingsDataTableFilter(source, {
    identifier: 'dateFilter',
    title: i18n.t('space_control.my-bookings.datatable.filters.date'),
    path: 'date',
    default: true,
    type: FilterType.Date,
    onUpdateValue: () => {
      track(trackingEvents.spaceControl.bookings.filterBookings, {
        filter_used: 'date',
      })
    },
    categories: [
      {
        kind: 'DatePicker',
        operation: 'between',
        value: [
          dateToString(moment(), 'backend_datetime'),
          dateToString(moment().add(7, 'days'), 'backend_datetime'),
        ],
      },
    ],
  })

export default dateFilter
